import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="foot">
          <div className="foot-brand">
            <div className="brand">
              <img src={logo} alt="Instafrnd" className="foot-brand-logo" style={{ borderRadius: 6 }} />
            </div>
            <p>
              Find your IF. India's purpose-driven platform to connect through
              what you love — learn, do, become.
            </p>
          </div>
          <div className="foot-cols">
            <div className="foot-col">
              <h4>Product</h4>
              <Link to="/">Home</Link>
              <Link to="/safety">Safety Center</Link>
              <Link to="/become-a-coach">Conversation Coach</Link>
              <Link to="/become-celeb">Become a Celeb</Link>
            </div>
            <div className="foot-col">
              <h4>Company</h4>
              <a href="#about">About</a>
              <a href="#careers">Careers</a>
              <a href="#press">Press</a>
              <Link to="/contact">Contact</Link>
            </div>
            <div className="foot-col">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/child-safety">Child Safety</Link>
              <a href="#terms">Terms of Use</a>
              <a href="#guidelines">Community Guidelines</a>
              <Link to="/safety">Safety Center</Link>
            </div>
          </div>
        </div>
        <div className="foot-bot">
          <div>
            <div>Business Registered Name — Spynzo (OPC) Private Limited</div>
            <div>© 2026 Spynzo (OPC) Private Limited. All rights reserved.</div>
          </div>
          <div>Made in India 🇮🇳 · Find your IF</div>
        </div>
      </div>
    </footer>
  );
}
